import { use_slice_generation, use_slice_words } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { G_BUTTON__token_related_words_create } from './G_BUTTON__token_related_words_create';
import { G_BUTTON__token_related_words_show } from './G_BUTTON__token_related_words_show';

interface Props {
  field: FIELD__token;
}

//button visible only if user received related words
export function G_VIEW__token_related_words_buttons({ field }: Props) {
  /*
   * STORE
   */
  const { words_with_related_words_map } = use_slice_words(['words_with_related_words_map']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * METHODS
   */

  function is_related_words_received() {
    return words_with_related_words_map.has(field.word_english.get_value());
  }

  function is_any_related_words_dont_used_yet() {
    if (!is_related_words_received()) return false;

    let word_with_related_words = words_with_related_words_map.get_or_assert(field.word_english.get_value(), { context: 'word_with_related_words' });

    let out = false;

    let related_words = [...word_with_related_words.antonyms, ...word_with_related_words.synonyms];

    for (let related_word of related_words) {
      let word_used = generation_current.settings.tokens.some(token => token.word_english === related_word);

      if (!word_used) {
        out = true;
        break;
      }
    }

    return out;
  }

  /*
   * HTML
   */

  if (!field.is_one_word()) return <PLACEHOLDER_BUTTON__bar />;
  if (!is_related_words_received()) return <PLACEHOLDER_BUTTON__bar />;

  let out = <></>;

  if (is_any_related_words_dont_used_yet()) {
    out = <G_BUTTON__token_related_words_show {...{ field }} />;
  } else {
    out = <G_BUTTON__token_related_words_create {...{ field: field }} />;
  }

  return out;
}
